import { Fragment } from "react";
import NoImg from "../images/no-image.png";
import PropTypes from "prop-types";

//MUI
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Skeleton from "@material-ui/lab/Skeleton";

import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme) => ({
  card: {
    maxWidth: "100%",
    margin: theme.spacing(2),
  },
});

const PostSkeleton = ({ classes }) => {
  const content = Array.from({ length: 1 }).map((item, index) => (
    <Card className={classes.card} key={index}>
      <CardHeader
        avatar={
          <Skeleton animation="wave" variant="circle" width={40} height={40} />
        }
        action={null}
        title={
          <Skeleton
            animation="wave"
            height={10}
            width="80%"
            style={{ marginBottom: 6 }}
          />
        }
        subheader={<Skeleton animation="wave" height={10} width="40%" />}
      />
      <CardContent>
        <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
        <Skeleton animation="wave" height={10} width="80%" />
      </CardContent>
    </Card>
  ));

  return <Fragment>{content}</Fragment>;
};

PostSkeleton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PostSkeleton);
